import script from "./Profesional.vue?vue&type=script&setup=true&lang=ts"
export * from "./Profesional.vue?vue&type=script&setup=true&lang=ts"

import "./Profesional.vue?vue&type=style&index=0&id=96ef687c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96ef687c"]])

export default __exports__